module.exports = __webpack_public_path__ + "static/media/user-circle.dc813156.svg";